<template>
  <div>
    <h4 class="section-title">
      {{title}}
      <span class="section-sub-title">共為您搜尋到 {{itemsCount}} 筆資料</span>
      <span class="section-sub-title">資料來源：政府電子採購網</span>
    </h4>
    <div class="table-set">
      <!-- <div class="table-toolbar">
        <div class="toolbar-left">
          <el-date-picker
            v-model="startDate"
            type="date"
            placeholder="起始日期"
            size="mini"
            class="toolbar-input"
            value-format="yyyy-MM-dd"
            @change="search">
          </el-date-picker>
          <span class="connect">至</span>
          <el-date-picker
            v-model="endDate"
            type="date"
            placeholder="結束日期"
            size="mini"
            class="toolbar-input"
            value-format="yyyy-MM-dd"
            @change="search">
          </el-date-picker>
          <!- - <el-select class="toolbar-input" v-model="searchType" placeholder="搜尋方式" size="mini">
            <el-option
              v-for="item in searchTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              @change="search">
            </el-option>
          </el-select>
          <el-tooltip class="item" effect="dark" content="@Q@ 其實我也不知道這個是什麼" placement="bottom">
            <font-awesome-icon :icon="['far', 'question-circle']" style="vertical-align:middle;margin-right: 4px;"/>
          </el-tooltip> - ->
        </div>
      </div> -->
      <el-table
        :data="currentData.list"
        v-loading="isLoading"
        empty-text="目前暫無資料喔 :)"
        highlight-current-row
        stripe>
        <el-table-column
          label="序號"
          type="index"
          align="center"
          width="56">
        </el-table-column>
        <el-table-column
          label="刊登機關名稱"
          width="180">
          <template slot-scope="scope">
            {{scope.row.org_name | emptyFormat}}
          </template>
        </el-table-column>
        <el-table-column
          label="標案名稱"
          width="200">
          <template slot-scope="scope">
            {{scope.row.bid_name | emptyFormat}}
          </template>
        </el-table-column>
        <el-table-column
          label="符合政府採購法第101條所列之情形">
          <template slot-scope="scope">
            {{scope.row.base_law | emptyFormat}}
          </template>
        </el-table-column>
        <el-table-column
          label="拒絕往來生效日"
          width="100">
          <template slot-scope="scope">
            {{scope.row.date_start | emptyFormat}}
          </template>
        </el-table-column>
        <el-table-column
          label="拒絕往來截止日"
          width="100">
          <template slot-scope="scope">
            {{scope.row.date_end | emptyFormat}}
          </template>
        </el-table-column>
        <el-table-column
          label="異議或申訴結果"
          width="200">
          <template slot-scope="scope">
            {{scope.row.appeal | emptyFormat}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="align-right">
      <el-pagination
        layout="prev, pager, next"
        :total="searchTableCount"
        :current-page.sync="currentPage"
        @current-change="search">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as apis from '@/apis/index.ts'
import * as codes from '@/const/codes.ts'
import * as config from '@/const/config.js'
// import searchTypeOptions from '@/const/searchTypeOptions.js'

export default {
  props: {
    'title': {
      default () {
        return codes.COMPANY_DETAIL_ITEM_DICT.procurement_bad_vendors
      }
    },
    'procurement_bad_vendors': {
      required: true,
      default () {
        return {
          list: [],
          stat: {}
        }
      }
    },
    'uniID': {
      required: true
    }
  },
  data () {
    return {
      // searchTypeOptions,
      isLoading: false,
      currentData: {
        list: [],
        stat: {}
      },
      startDate: '',
      endDate: moment().format('YYYY-MM-DD'),
      searchType: '',
      currentPage: 1
    }
  },
  computed: {
    itemsCount () {
      if (this.currentData.stat['total-count']) {
        return this.currentData.stat['total-count']
      } else {
        return 0
      }
    },
    searchTableCount () {
      if (this.currentData.stat['total-count']) {
        if (this.currentData.stat['total-count'] > config.SEARCH_MAX_COUNT) {
          return config.SEARCH_MAX_COUNT
        } else {
          return this.currentData.stat['total-count']
        }
      } else {
        return 0
      }
    },
  },
  methods: {
    search () {
      let searchRequest = {
        get: {
          procurement_bad_vendors: {
            'page-index': this.currentPage,
            time: {}
          }
        },
        uniID: this.uniID
      }
      // if (this.startDate) {
      //   searchRequest.get.procurement_bad_vendors.time.start = this.startDate
      // }
      // if (this.endDate) {
      //   searchRequest.get.procurement_bad_vendors.time.end = this.endDate
      // }
      this.isLoading = true
      apis.companyGet(searchRequest)
        .then((data) => {
          this.isLoading = false
          if (data.payload.procurement_bad_vendors) {
            this.currentData = data.payload.procurement_bad_vendors
          }
        })
        .catch(e => {
          this.isLoading = false
        })
    }
  },
  watch: {
    'procurement_bad_vendors': {
      handler (d) {
        if (d) {
          this.currentData = JSON.parse(JSON.stringify(d))
        }
      },
      immediate: true
    }
  }
}
</script>
